export interface BaseSprint {
    id: number;
    name: string;
    description: string;
    start_date: Date;
    created_on: Date;
    effective_date: Date;
    status: string;
    sharing: string;
}

export function BaseSprintFromJSON(json: any): BaseSprint {
    return {
        id: json["id"],
        name: json["name"],
        description: json["description"],
        start_date: new Date(json["start_date"]),
        created_on: new Date(json["created_on"]),
        effective_date: new Date(json["effective_date"]),
        status: json["status"],
        sharing: json["sharing"],
    }
}

export interface Sprint {
    id: number;
    name: string;
    created_on: Date;
    effective_date: Date;
    next: BaseSprint;
    previous: BaseSprint;
}

export function SprintFromJSON(json: any): Sprint {
    return {
        id: json["id"],
        name: json["name"],
        created_on: new Date(json["created_on"]),
        effective_date: new Date(json["effective_date"]),
        next: BaseSprintFromJSON(json["next"]),
        previous: BaseSprintFromJSON(json["previous"]),
    }
}
